import {
    LoadingIndicator,
    React,
    Section,
    Text,
    Title,
    TouchableOpacity
} from '../../../common';
import { COLORS } from '../../../styles/colors';
import { sectionStyle } from '../../Doctors/DoctorsSearch/style';
import { visitInput as styles } from '../style';
import { DownArrowIcon } from './DownArrowIcon';

export const ComboboxSelector = ({
    isLoading: loadingState,
    enabled,
    onPressHandler = () => {
    },
    title = '',
    value = '',
    isError = false,
    containerStyle = {},
}) => {
    return (
        <Section style={{ ...sectionStyle, ...containerStyle }}>
            {title ? <Text style={styles.inputHeader}>{Object.R(title)}</Text> : null}
            {loadingState ? (
                <LoadingIndicator indicatorSize={30}/>
            ) : (
                <TouchableOpacity
                    disabled={!enabled}
                    onPress={onPressHandler}
                    style={[
                        styles.containerInput,
                        isError
                            ? {
                                borderWidth: 1,
                                borderColor: COLORS.ERROR,
                            }
                            : {},
                    ]}
                >
                    <Title.Bigger
                        numberOfLines={1}
                        style={{...styles.inputText, ...{paddingRight: 40, width: '100%' }}}>{value}</Title.Bigger>
                    {!enabled ? null : <DownArrowIcon onPress={onPressHandler}/>}
                </TouchableOpacity>
            )}
        </Section>
    );
};
